{
    "common": {
        "billing": "Facturación",
        "crewLead": "Líder de cuadrilla",
        "crewLead_union": "Conductor",
        "crewLeads": "Líderes de cuadrilla",
        "crewLeads_union": "Conductores",
        "crewLeadUpper": "LÍDER DE CUADRILLA",
        "crewLeadUpper_union": "CONDUCTOR",
        "save": "Guardar",
        "cancel": "Cancelar",
        "delete": "Eliminar",
        "yesDelete": "Sí, eliminar",
        "deleting": "Eliminando",
        "edit": "Editar",
        "close": "Cerrar",
        "clear": "Borrar",
        "remove": "Quitar",
        "removing": "Quitando",
        "loading": "Cargando...",
        "yes": "Sí",
        "no": "No",
        "language": "Idioma",
        "languageNative": "Idioma",
        "english": "Inglés",
        "spanish": "Español",
        "errorPrefix": "Error:",
        "add": "Agregar",
        "warning": "Advertencia",
        "backToHome": "Volver al inicio"
    },
    "auth": {
        "signIn": "Iniciar sesión",
        "signOut": "Cerrar sesión",
        "register": "Registrarse",
        "username": "Usuario",
        "password": "Contraseña",
        "rememberMe": "Recordarme",
        "forgotPassword": "¿Olvidó su contraseña?",
        "checkingCredentials": "Verificando credenciales...",
        "signingIn": "Iniciando sesión...",
        "signInError": "Hubo un problema al iniciar sesión.",
        "manageAccount": "Administrar cuenta"
    },
    "nav": {
        "myCalendar": "Mi Calendario",
        "nonFlaggingTimesheet": "Hoja de Horas (No Banderillero)",
        "myTimesheets": "Mis Hojas de Horas",
        "timeTracker": "Registro de Tiempo",
        "languagePreference": "Preferencia de idioma",
        "myWork": "Mi Trabajo",
        "addTimesheet": "Agregar Hoja de Horas",
        "jobCalendar": "Calendario de Trabajos",
        "logOut": "Log Out",
        "changeLanguage": "Change Language",
        "quickLinks": "Quick Links",
        "subscribeDispatchPlusNotifications": "Subscribe to Dispatch Plus Notifications",
        "unsubscribeDispatchPlusNotifications": "Unsubscribe from Dispatch Plus Notifications",
        "dispatchPlusNotificationSubscriptionSaved": "Notification preference saved",
        "dispatchPlusNotificationSubscriptionSaveError": "There was a problem saving your notification preference"
    },
    "calendar": {
        "allDay": "Todo el día",
        "previous": "Anterior",
        "next": "Siguiente",
        "today": "Hoy",
        "month": "Mes",
        "week": "Semana",
        "day": "Día",
        "agenda": "Agenda",
        "date": "Fecha",
        "time": "Hora",
        "event": "Evento",
        "noEventsInRange": "No hay eventos en este rango.",
        "showMore_one": "+{{count}} más",
        "showMore_other": "+{{count}} más",
        "legendUnconfirmed": "Sin confirmar",
        "legendConfirmed": "Confirmado",
        "legendTimeRejected": "Tiempo rechazado",
        "errorBoundary": "El calendario no pudo cargarse.",
        "eventTitleWithJob": " - {{title}}"
    },
    "timesheet": {
        "crewTimesheet": "Hoja de horas de la cuadrilla",
        "backToMyTimesheets": "Volver a Mis hojas de horas",
        "gettingTimesheet": "Obteniendo hoja de horas...",
        "noTimesheetData": "No hay datos de hoja de horas disponibles.",
        "status": "Estado",
        "submittedOn": "Enviada el {{when}}",
        "byUser": "por {{user}}",
        "notYetSubmitted": "Aún no enviada",
        "employee": "Empleado",
        "date": "Fecha",
        "timesheetDetails": "Detalles de la hoja de horas",
        "notesLabel": "Notas",
        "notAvailable": "N/D",
        "total": "Total",
        "employeeSignature": "Firma del empleado",
        "noSignatureAvailable": "No hay firma disponible",
        "timesheetNumber": "Número de hoja de horas",
        "timesheets": "Hojas de horas",
        "gettingTimesheets": "Obteniendo hojas de horas...",
        "noTimesheetsFound": "No se encontraron hojas de horas.",
        "newNonFlaggingTimesheet": "Nueva hoja de horas (No banderillero)",
        "newSelfDispatchTimesheet": "Nueva hoja de horas (Auto-despacho)",
        "employeeTimesheet": "Hoja de horas del empleado",
        "addTimesheet": "Agregar hoja de horas",
        "resubmitTimesheet": "Reenviar hoja de horas",
        "unsavedChangesPrompt": "Tiene cambios sin guardar, ¿está seguro de que desea salir?",
        "dateRequired": "La fecha es obligatoria.",
        "contract": "Contrato",
        "charge": "Cargo",
        "chargeRequired": "Se requiere un cargo.",
        "equipment": "Equipo",
        "equipmentRequired": "Se requiere seleccionar un equipo.",
        "units": "Unidades",
        "enterValue": "Ingrese un valor",
        "valueRequired": "El valor es obligatorio y debe ser mayor que cero.",
        "startTime": "Hora de inicio",
        "startTimeRequired": "La hora de inicio es obligatoria.",
        "endTime": "Hora de finalización",
        "endTimeRequired": "La hora de finalización es obligatoria.",
        "employeeSignaturePreview": "Vista previa de la firma del empleado",
        "confirmDelete": "¿Está seguro de que desea eliminar esta hoja de horas?",
        "notes": "Notas",
        "deletionNotesPlaceholder": "Ingrese notas sobre la eliminación.",
        "timeEntryOverlap": "Esta entrada de tiempo se superpone con entradas que ya ha agregado para esta fecha.",
        "saved": "Hoja de horas guardada.",
        "deleted": "Hoja de horas eliminada.",
        "approvalPending": "Hoja de horas pendiente de aprobación",
        "approved": "Hoja de horas aprobada",
        "resetToSubmitted": "Hoja de horas restablecida a Enviada",
        "rejected": "Hoja de horas rechazada.",
        "restored": "Hoja de horas restaurada.",
        "errorApproving": "Error al aprobar la hoja de horas",
        "errorRestoring": "Error al restaurar la hoja de horas: {{error}}",
        "errorSoftDeleting": "Error al eliminar la hoja de horas: {{error}}",
        "countyRequired": "Se requiere seleccionar un condado para esta hoja de horas",
        "correctErrors": "Por favor corrija los errores resaltados.",
        "invalidTimeRange": "Por favor ingrese un rango de tiempo válido.",
        "contactSaved": "Contacto guardado.",
        "contactSaveError": "Error del servidor al guardar el contacto.",
        "attachmentsUpdated": "Adjuntos actualizados correctamente",
        "attachmentsUpdateFailed": "Error al actualizar los adjuntos",
        "attachmentDeleted": "Adjunto eliminado",
        "attachmentDeleteFailed": "Error al eliminar el adjunto",
        "rejectMissingBilling": "No se puede rechazar: falta el registro de facturación.",
        "rejectAlreadyInvoiced": "Esta hoja de horas ya fue facturada y no puede ser rechazada.",
        "rejectAlreadyApproved": "Un administrador debe rechazar esta hoja de horas porque ya está aprobada",
        "billingChargesRejected": "Facturación: Cargos rechazados",
        "jobDetails": "Detalles del trabajo",
        "jobDetailsWithName": "Detalles del trabajo - {{name}}",
        "backToCalendar": "Volver al calendario",
        "rejectionHistoryHeader": "Rechazo de la hoja de horas",
        "rejectionDate": "Fecha",
        "rejectedBy": "Rechazado por",
        "rejectionNotes": "Notas",
        "meetingLocation": "Lugar de encuentro",
        "jobLocation": "Lugar del trabajo",
        "county": "Condado",
        "timesheetAttachments": "Adjuntos de la hoja de horas",
        "uploadFiles": "Subir archivos",
        "timesheetHeader": "HOJA DE HORAS",
        "clientSig": "Firma cliente",
        "crewSig": "Firma cuadrilla",
        "dateStart": "Fecha/Inicio",
        "customer": "Cliente",
        "dispatch": "Despacho",
        "contractLabel": "Contrato",
        "jobLabel": "Trabajo",
        "foreman": "Capataz",
        "requestor": "Solicitante",
        "openInGoogleMaps": "Abrir en Google Maps",
        "editTimesheet": "Editar hoja de horas",
        "addOptionalCharge": "Agregar cargo opcional",
        "jobLocationOverride": "Cambiar ubicación de trabajo",
        "meetingLocationOverride": "Cambiar lugar de encuentro",
        "addressNotGeocoded": "La dirección no está geocodificada. Haga clic en Editar para ingresar una dirección verificable.",
        "optional": "(Opcional)",
        "requiredPlaceholder": "(Obligatorio)",
        "workTruckDaily": "Camión de trabajo - Diario",
        "truck": "Camión",
        "flagging": "Banderillero",
        "lunchBreakFlagging": "Descanso para almorzar (Banderillero)",
        "notesOptional": "(Opcional, límite de 2000 caracteres)",
        "paintBatchCode": "Paint Batch Code",
        "paintBatchCodePlaceholder": "ex: W-123 (separate codes with a comma)",
        "paintBatchCodeTooLong": "A paint batch code can be at most {{max}} characters.",
        "paintBatchCodesLimitReached": "Up to {{max}} paint batch codes can be recorded. Remove one before adding another.",
        "paintBatchPhotos": "Paint Batch Photos",
        "startUpper": "INICIO",
        "stopUpper": "FIN",
        "addCharge": "Agregar cargo",
        "noEntriesAdded": "No se agregaron entradas.",
        "time": "Hora",
        "signatureColon": "Firma:",
        "signature": "Firma",
        "submitTimesheet": "Enviar hoja de horas",
        "timesheetCompleted": "Esta hoja de horas fue completada.",
        "attachmentsWarning": "¿Está seguro de que desea continuar sin archivos adjuntos?",
        "yesContinue": "Sí, continuar",
        "statusNew": "Nueva",
        "statusClientReview": "Revisión del cliente",
        "statusSubmitted": "Enviada",
        "statusRejected": "Rechazada",
        "statusCancelPending": "Cancelación pendiente",
        "statusApprovalPending": "Aprobación pendiente",
        "statusApproved": "Aprobada",
        "statusExported": "Exportada",
        "statusDeleted": "Eliminada",
        "statusOperationsReview": "Revisión de operaciones",
        "operationsReviewNotice": "AVISO: Este parte de horas está en revisión por Operaciones y no se puede editar ni reenviar.",
        "editTime": "Editar tiempo",
        "addTime": "Agregar tiempo",
        "saveTimeEntry": "Guardar entrada de tiempo",
        "deleteTimeEntry": "Eliminar entrada de tiempo",
        "pleaseSelectDate": "Por favor seleccione una fecha.",
        "durationFormat": "{{hours}}h {{minutes}}min",
        "approvedOn": "Aprobada el {{when}}",
        "rejectedBy": "Rechazada por",
        "rejectionReasonOn": "{{reason}} el {{when}}",
        "noSetupForRoute": "El administrador aún no ha realizado la configuración de esta ruta. Por favor, comuníquese con su supervisor o administrador.",
        "nonFlagContractNotCreated": "Contrato no banderillero no creado",
        "selfDispatchContractNotCreated": "Contratos de auto-despacho no creados",
        "nonFlagSetupNotComplete": "El administrador aún no ha realizado la configuración para las hojas de horas no banderilleras. Espere a que esta tarea esté completa antes de intentar ingresar tiempo no banderillero en el sistema.",
        "linkedTimesheetNote": "NOTA: Esta acción agrega otra hoja de horas al trabajo y solo debe usarse si se necesita más de una hoja. Por ejemplo: si necesita enviar hojas de horas separadas para distintas órdenes de trabajo del cliente. Si NO necesita una hoja adicional, seleccione \"Cancelar\" y complete las hojas existentes.",
        "adjBadge": "AJU",
        "nfBadge": "NB",
        "notesUpper": "NOTAS",
        "deleteTimesheet": "Eliminar hoja de horas",
        "loadingEquipment": "Cargando equipo...",
        "submitPreJobForm": "Enviar formulario previo al trabajo",
        "preJobNotSubmitted": "El formulario previo al trabajo no se ha enviado.",
        "viewEditPreJobForm": "Ver/Editar formulario previo al trabajo",
        "timesheetSubmittedHeader": "Hoja de horas enviada",
        "timesheetSubmittedBody": "Esta hoja de horas se ha enviado.",
        "timesheetIncompleteHeader": "Hoja de horas incompleta",
        "timesheetIncompleteBody": "Asegúrese de que todos los registros de la hoja de horas estén completos y enviados.",
        "timesheetTitleParts": "{{customer}}{{subcontractorPart}} - {{jobNumber}}",
        "subcontractorPart": " - {{name}}",
        "woNumberPrefix": "OT #:",
        "timesheetDeletedNotice": "Esta hoja de horas se eliminó y no se puede modificar.",
        "previousStepsIncompleteHeader": "Pasos previos incompletos",
        "previousStepsIncompleteBody": "Asegúrese de que la hoja de horas esté completa y enviada antes de la revisión del cliente.",
        "preJobIncompletePrompt": "El formulario previo al trabajo está incompleto. ¿Desea continuar con el envío de la hoja de horas?",
        "qty": "Cant.",
        "maximumWithValue": "(Máximo: {{max}})",
        "estimatedTravelTime": "Tiempo de viaje estimado:",
        "sameForAll": "¿Igual para todos?",
        "workOrderHashLabel": "Orden de trabajo #",
        "submissionInvalid": "Su envío contiene entradas no válidas.",
        "addressMustBeGeocoded": "La dirección debe estar geocodificada. Ingrese una dirección completa con calle, ciudad y estado para que pueda verificarse.",
        "minimumOneSetupCharge": "La hoja de horas debe tener al menos un cargo de configuración.",
        "errorSaving": "Error al guardar la hoja de horas.",
        "errorSavingHeader": "Hubo un problema al guardar",
        "errorSavingUnexpectedHeader": "Problema inesperado al guardar la hoja de horas",
        "errorDeletingUnexpectedHeader": "Problema inesperado al eliminar la hoja de horas",
        "fileAttachmentsRequired": "Se requieren archivos adjuntos",
        "sendSmsTo": "Enviar SMS a {{name}}",
        "confirmedTooltip": "Confirmado",
        "clickToConfirmTooltip": "Haga clic para confirmar",
        "reviewCompleteTooltip": "Completo",
        "reviewIncompleteTooltip": "Complete tanto la hoja de horas como la Revisión del cliente para realizar la Revisión de cuadrilla.",
        "requestedPrefix": "Solicitado:",
        "employeeReviewSaveError": "No pudimos guardar la revisión de su hoja de horas.  Mensaje del servidor: {{error}}",
        "signatureRequired": "Se requiere una firma.",
        "noSignatureReasonRequired": "Indique el motivo por el cual no hay firma.",
        "noSignatureReasonSelectionRequired": "Motivo por el cual no hay firma: se requiere una selección en el menú desplegable.",
        "workCardRequired": "Se requiere una tarjeta de trabajo.",
        "jobTypeSelectionRequired": "Se requiere seleccionar un tipo de trabajo.",
        "explanationRequired": "Debe proporcionar una explicación",
        "requiredQuestionsMissing": "Faltan respuestas en algunas preguntas obligatorias",
        "crewReviewSignatureTitle": "Revisión de cuadrilla / Firma",
        "employeeLabel": "Empleado",
        "workOrder": "Orden de trabajo",
        "workTypeQuestion": "¿Qué tipo de trabajo realizó hoy?",
        "driverAgreement": "Acuerdo del conductor",
        "driverAgreementText": "Como conductor, dispatch/gerente me indicó que llevara a mi compañero hacia/desde el trabajo hoy.",
        "wasProjectCompletedLabel": "Was the project completed on this timesheet?",
        "signatureType": "Tipo",
        "signatureTypeRequired": "Se requiere un tipo de firma del empleado.",
        "employeeSignatureLabel": "Firma del empleado:",
        "signaturePreview": "Vista previa de la firma",
        "uploadWorkCard": "Cargar tarjeta de trabajo",
        "workCardAlt": "Tarjeta de trabajo",
        "workCardRequiredForTimesheet": "Se requiere una tarjeta de trabajo para esta hoja de horas.",
        "earlyDepartureLeftEarlyLabel": "¿El empleado se fue antes de estar autorizado a retirarse?",
        "earlyDepartureDurationLabel": "Con cuánta anticipación se fue el empleado?",
        "earlyDepartureDurationRequired": "La duración de la salida anticipada es obligatoria cuando el empleado se fue antes de estar autorizado a retirarse.",
        "reuseSignatureLabel": "[Admin] Reutilizar firma",
        "driverNonFlaggingNotice": "Conductor, complete una hoja de horas sin abanderamiento para registrar el tiempo dedicado a recoger y dejar a su compañero hacia/desde el lugar de trabajo.",
        "workOrderBracketed": "[{{number}}]",
        "invalidEmailAddress": "Ingrese una sola dirección de correo electrónico válida.",
        "resetClientSignatureTitle": "Restablecer la firma del cliente",
        "resetClientSignatureBody": "¿Está seguro de que desea restablecer la firma del cliente? El cliente deberá volver a firmar el documento.",
        "resetClientSignatureSaveLabel": "Restablecer",
        "resetClientSignatureSavingLabel": "Restableciendo...",
        "clientSignatureResetSuccess": "Firma del cliente restablecida. El cliente deberá firmar nuevamente.",
        "clientSignatureResetError": "No se pudo restablecer la firma del cliente.",
        "clientSignatureResetErrorForApprovedTimesheet": "La hoja de tiempo ya ha sido aprobada.",
        "clientReviewSignatureRequired": "Se requiere una firma.",
        "clientReviewNoSignatureReasonRequired": "Indique el motivo por el cual no hay firma.",
        "clientReviewNoSignatureReasonSelectionRequired": "Motivo por el cual no hay firma: se requiere una selección en el menú desplegable.",
        "summaryOfBillableCharges": "Resumen de cargos facturables",
        "clientReviewSignatureTitle": "Revisión del cliente / Firma",
        "resetClientSignatureLabel": "Restablecer firma del cliente",
        "missingSignatureReason": "Motivo de firma faltante",
        "missingSignatureReasonRequired": "Se requiere un motivo.",
        "missingSignatureNotesPlaceholder": "Ingrese notas sobre por qué no hay firma.",
        "missingSignatureNotesRequired": "Se requieren notas",
        "signatureTypeColon": "Tipo:",
        "clientSignatureTypeRequired": "Se requiere un tipo de firma del cliente.",
        "clientSignatureLabel": "Firma del cliente:",
        "timesheetAdded": "Hoja de horas agregada.",
        "timesheetAddError": "Error al agregar la hoja de horas.",
        "purchaseOrderHashLabel": "Orden de compra #",
        "workRequestHashLabel": "Solicitud de trabajo #",
        "minimumChargeFromCancel": "Tipo de cargo mínimo por cancelación",
        "removeChargeType": "Quitar este tipo de cargo",
        "exceedsThreshold": "Las horas superan el umbral sugerido",
        "toggleStartStopApplies": "Alternar si aplica el tiempo de inicio y fin para este tipo de cargo.",
        "enterFieldNote": "Ingrese una nota de campo (obligatorio)",
        "enterValueLabel": "Ingrese un valor",
        "openInGoogleMapsTooltip": "Abrir en Google Maps",
        "jobAttachmentsLabel": "Adjuntos del trabajo",
        "employeeConfirmed": "Empleado confirmado",
        "equipmentConfirmed": "Equipo confirmado",
        "submitNewPreJobTooltip": "Haga clic para enviar un nuevo formulario previo al trabajo.",
        "viewEditPreJobTooltip": "Haga clic para ver o editar el formulario previo al trabajo.",
        "clientReviewDetails": "Detalles de revisión del cliente",
        "employeeReviewDetails": "Detalles de revisión del empleado",
        "editTimeEntryTooltip": "Haga clic para editar esta entrada de tiempo",
        "removeTimeEntryTooltip": "Haga clic para quitar esta entrada de tiempo"
    },
    "confirm": {
        "driverDisclaimerRequired": "Por favor acepte la advertencia del conductor antes de enviar.",
        "loadFailed": "Hubo un problema al obtener la asignación del trabajo.",
        "jobDetails": "Detalles del trabajo",
        "jobDetailsWithName": "Detalles del trabajo - {{name}}",
        "notFound": "No se pudo encontrar el recurso solicitado.",
        "alertConfirmed": "Esta asignación ha sido confirmada.",
        "alertCancelled": "Esta asignación ha sido cancelada.",
        "alertCancelledAndConfirmed": "Esta asignación ha sido cancelada y confirmada.",
        "alertCancelledByCustomer": "Esta asignación ha sido cancelada por el cliente.",
        "meetingLocation": "Lugar de encuentro",
        "jobLocation": "Lugar del trabajo",
        "county": "Condado",
        "jobAttachments": "Adjuntos del trabajo",
        "driverDisclaimerLabel": "Advertencia del conductor",
        "driverDisclaimerText": "Los empleados no están obligados ni se espera que den traslados desde o hacia los sitios de trabajo. A menos que la empresa lo solicite, es voluntario y no cuenta como horas trabajadas",
        "driverDisclaimerMustAgree": "Debe aceptar la advertencia antes de continuar.",
        "crewAndEquipment": "Cuadrilla y equipo",
        "sendGroupSmsToCrew": "Enviar SMS grupal a la cuadrilla",
        "dispatchedFrom": "(Despachado desde {{name}})",
        "quantitySuffix": "(Cantidad: {{quantity}})",
        "assignedTo": "(Asignado a: {{name}})",
        "assignedToYouTooltip": "Asignado a usted",
        "assignedToEquipment": "(Asignado a: {{type}} {{name}})",
        "dropoff": "Entrega",
        "pickup": "Recolección",
        "dropoffWithQty": "Entrega: {{quantity}}",
        "pickupWithQty": "Recolección: {{quantity}}",
        "officeWithNumber": "Oficina - {{number}}",
        "confirm": "Confirmar",
        "confirmCancellation": "Confirmar cancelación",
        "goToTimesheet": "Ir a la hoja de horas",
        "callOff": "Notificar Ausencia",
        "callOffSubmitting": "Enviando",
        "callOffSubmitted": "Su aviso de ausencia ha sido enviado a la central de despacho.",
        "callOffSubmitFailed": "No es posible enviar su aviso de ausencia. Por favor, contáctese con el centro de despacho.",
        "callOffDisclaimerLoadFailed": "No se pudo cargar el aviso de notificación de ausencia.",
        "callOffAcknowledgeRequired": "Por favor, acepte el aviso antes de enviar.",
        "callOffNotesLabel": "Notas (opcional)",
        "callOffNotesPlaceholder": "Añada cualquier detalle para el centro de despacho.",
        "callOffAcknowledgement": "Entiendo y acepto lo anterior.",
        "assignedEmployeeWithLead": "{{name}} ({{lead}})",
        "assignedEquipmentBase": "{{type}} : {{name}}",
        "assignedEquipmentWithQty": "{{type}} : {{name}} {{qtySuffix}}"
    },
    "tenant": {
        "supportedLanguages": "Idiomas admitidos",
        "supportedLanguagesHelp": "Idiomas que el personal puede elegir. El inglés es obligatorio.",
        "supportedLanguagesSaved": "Idiomas admitidos actualizados.",
        "supportedLanguagesSaveError": "No se pudieron actualizar los idiomas admitidos."
    },
    "employee": {
        "preferredLanguage": "Idioma preferido",
        "preferredLanguageSaved": "Idioma preferido actualizado.",
        "preferredLanguageSaveError": "No se pudo actualizar el idioma preferido.",
        "noLinkedUser": "Este empleado no tiene una cuenta de usuario vinculada.",
        "onCallAvailabilityLabel": "Available for last minute call in and emergency jobs",
        "onCallAvailabilitySaved": "On call availability updated",
        "onCallAvailabilitySaveError": "There was a problem updating your on call availability",
        "onCallRestrictedMessage": "Your ability to be on-call has been restricted due to refusing job offers. Reach out to your OM for more details."
    },
    "timeTracker": {
        "noJobsScheduled": "No hay trabajos programados",
        "shiftCompleted": "Turno completado",
        "startShift": "Iniciar turno",
        "endShift": "Finalizar turno",
        "startJob": "Iniciar trabajo",
        "endJob": "Finalizar trabajo",
        "currentShiftStarted": "Turno actual iniciado:",
        "shiftStarted": "Turno iniciado:",
        "shiftCompletedLabel": "Turno completado:",
        "currentJob": "Trabajo actual",
        "todaysJobs": "Trabajos de hoy",
        "startTimeLabel": "Hora de inicio:",
        "overrideTime": "Anular hora",
        "time": "Hora",
        "timeRequired": "Se requiere una hora",
        "notes": "Notas",
        "noteRequired": "Se requiere una nota",
        "confirm": "Confirmar",
        "confirming": "Confirmando",
        "confirmStartShift": "Confirmar inicio de turno",
        "confirmEndShift": "Confirmar fin de turno",
        "confirmStartJob": "Confirmar inicio de trabajo",
        "confirmEndJob": "Confirmar fin de trabajo",
        "shiftStartedSuccess": "Turno iniciado",
        "shiftEndedSuccess": "Turno finalizado",
        "jobStartedSuccess": "Trabajo iniciado",
        "jobEndedSuccess": "Trabajo finalizado",
        "failedStartShift": "Error al iniciar el turno",
        "failedEndShift": "Error al finalizar el turno",
        "failedStartJob": "Error al iniciar el trabajo",
        "failedEndJob": "Error al finalizar el trabajo",
        "couldNotLoadJobs": "No se pudieron cargar los datos de trabajos",
        "overrideTimeRequired": "El valor de anulación de hora es obligatorio",
        "notesRequired": "Las notas son obligatorias",
        "noJobSelected": "No hay trabajo seleccionado",
        "noTime": "Sin hora",
        "customerLabel": "Cliente:",
        "workOrderLabel": "OT#:",
        "jobLocationLabel": "Ubicación del trabajo:",
        "meetingLocationLabel": "Lugar de encuentro:",
        "jobStartedTooltip": "Trabajo iniciado:",
        "jobCompletedTooltip": "Trabajo completado:",
        "jobStartBeforeShift": "La hora de inicio del trabajo {{eventTime}} no puede ser anterior a la hora de inicio del turno ({{shiftStart}})",
        "jobEndBeforeStart": "La hora de fin del trabajo {{eventTime}} no puede ser anterior a la hora de inicio del trabajo {{startTime}}",
        "shiftEndBeforeStart": "La hora de fin del turno {{eventTime}} no puede ser anterior a la hora de inicio del turno {{shiftStart}}",
        "shiftEndBeforeLatestJobEnd": "La hora de fin del turno {{eventTime}} no puede ser anterior a la hora de fin del último trabajo {{jobEnd}}",
        "shiftEndTooCloseToNextJob": "No se puede finalizar el turno a las {{eventTime}}: el próximo trabajo comienza a las {{nextJob}} (debe haber al menos 1 hora de separación)",
        "shiftStartBeforePrevious": "La hora de inicio del turno {{eventTime}} no puede ser anterior a la hora de fin del turno anterior {{previousEnd}}"
    }
}